import { ActionButton, SimpleText, useWindowDimensions, ActiveButton } from '@my/ui'

import assets from '../../assets/images'
import { color, TZABrandGuidelines, useLink } from '@my/util'
import { defaultTo } from 'lodash'
import { Platform } from 'react-native'

export const dataHome = Platform.select({
  web: [
    {
      key: 'Financial Snapshot',
      img: assets?.FinancialSnapshot,
      imgHeight: 33,
      imgWidth: 33,
      link: '/financial-snapshot',
    },
    {
      key: 'Budget Analysis',
      img: assets?.spendingAnalysis,
      imgHeight: 33,
      imgWidth: 33,
      link: '/financial-spending',
    },
    {
      key: 'Financial Goals',
      img: assets?.financialGoals,
      imgHeight: 33,
      imgWidth: 33,
      link: '/financial-goals',
    },
    {
      key: 'Savings Forecast',
      img: assets?.cashFlow,
      imgHeight: 33,
      imgWidth: 33,
      link: '/financial-savingsforecast',
    },
    {
      key: 'Key Insights',
      img: assets?.keyInsight,
      imgHeight: 33,
      imgWidth: 33,
      link: '/key-insights',
    },
    {
      key: 'Recommendations',
      img: assets?.recommendation,
      imgHeight: 33,
      imgWidth: 33,
      link: '/recommendations',
    },
    {
      key: 'Financial Plan',
      img: assets?.financialPlan,
      imgHeight: 33,
      imgWidth: 33,
      link: '/financial-plan',
    },
    {
      key: 'Scenario Planning',
      img: assets?.scenarioPlanning,
      imgHeight: 33,
      imgWidth: 33,
      link: '/scenario-planning',
    },
    {
      key: 'Savvy',
      img: assets?.savvy,
      imgHeight: 33,
      imgWidth: 33,
      link: '/savvy',
    },
    {
      key: 'Advisor Match',
      img: assets?.advisor,
      imgHeight: 33,
      imgWidth: 33,
      link: '/advisor-match',
    },
    {
      key: 'Investments',
      img: assets?.investWithUs,
      imgHeight: 33,
      imgWidth: 33,
      link: '/investments',
    },
    {
      key: 'Profile Overview',
      img: assets?.profile,
      imgHeight: 33,
      imgWidth: 33,
      link: '/financial-profile',
    },
    /* {
      key: 'Settings',
      img: assets?.setting,
      imgHeight: 38,
      imgWidth: 38,
      link: '/settings',
    }, */
  ],
  native: [
    {
      key: 'Financial Snapshot',
      img: assets?.FinancialSnapshot,
      imgHeight: 33,
      imgWidth: 33,
      link: '/financial-snapshot',
    },
    {
      key: 'Budget Analysis',
      img: assets?.spendingAnalysis,
      imgHeight: 33,
      imgWidth: 33,
      link: '/financial-spending',
    },
    {
      key: 'Financial Goals',
      img: assets?.financialGoals,
      imgHeight: 33,
      imgWidth: 33,
      link: '/financial-goals',
    },
    {
      key: 'Savings Forecast',
      img: assets?.cashFlow,
      imgHeight: 33,
      imgWidth: 33,
      link: '/financial-savingsforecast',
    },
    {
      key: 'Key Insights',
      img: assets?.keyInsight,
      imgHeight: 33,
      imgWidth: 33,
      link: '/key-insights',
    },
    {
      key: 'Recommendations',
      img: assets?.recommendation,
      imgHeight: 33,
      imgWidth: 33,
      link: '/recommendations',
    },
    {
      key: 'Financial Plan',
      img: assets?.financialPlan,
      imgHeight: 33,
      imgWidth: 33,
      link: '/financial-plan',
    },
    {
      key: 'Scenario Planning',
      img: assets?.scenarioPlanning,
      imgHeight: 33,
      imgWidth: 33,
      link: '/scenario-planning',
    },
    {
      key: 'Savvy',
      img: assets?.savvy,
      imgHeight: 33,
      imgWidth: 33,
      link: '/savvy',
    },
    {
      key: 'Advisor Match',
      img: assets?.advisor,
      imgHeight: 33,
      imgWidth: 33,
      link: '/advisor-match',
    },
    {
      key: 'Investments',
      img: assets?.investWithUs,
      imgHeight: 33,
      imgWidth: 33,
      link: '/investments',
    },
    {
      key: 'Profile Overview',
      img: assets?.profile,
      imgHeight: 33,
      imgWidth: 33,
      link: '/financial-profile',
    },
  ]
});

export const insightsData = [
  {
    id: 1,
    insight:
      'While you have a solid income, your expenses, particularly in the categories of medical and traveling, are significantly high. By optimizing these expenses, you can free up additional funds for savings and debt repayment.',
  },
  {
    id: 2,
    insight:
      'Your budget analysis reveals a trend of overspending in certain discretionary categories. Adjusting your spending habits can increase your savings rate and help you reach your financial goals faster.',
  },
  {
    id: 3,
    insight:
      'Consider reallocating a portion of your investments to more stable assets to better protect against market volatility. This could help preserve your financial stability in uncertain times.',
  },
]

export const STORAGE_KEY = 'selectedAnswer'
export const QUESTION_KEY = 'currentQuestion'

export const AnswerButton: React.FC<AnswerButtonProps> = (params) => {
  const { answer, onPress, isSelected, isCorrect, isRevealed, index } = params
  const { width } = useWindowDimensions()

  // Helper functions for styles
  const getBackgroundColor = () => {
    if (!isRevealed) return 'white' //'#e2e2e2ff'
    if (isSelected) return isCorrect ? TZABrandGuidelines.colorsMap.primaryGreen : TZABrandGuidelines.colorsMap.secondarySalmon
    return isCorrect ? TZABrandGuidelines.colorsMap.primaryGreen : 'white' //'#e2e2e2ff'
  }

  const getTextColor = () => {
    return isRevealed && (isSelected || isCorrect) ? color.white : color.grey
  }

  const hoverTextColor = isRevealed ? getTextColor() : TZABrandGuidelines.colorsMap.primaryGreen;

  // Platform-specific styles
  const webStyles: any = {
    width: '100%'//width < 800 ? '90%' : '60%',
  }

  const nativeStyles: any = {
    minWidth: width < 500 ? '100%' : '40%',
  }

  //const dynamicProps = 

  return (
    <ActionButton
      disabled={isRevealed}
      onPress={onPress}
      $platform-web={webStyles}
      $platform-native={nativeStyles}
      hoverStyle={{borderColor: 'rgba(108, 117, 125, 0.64)', color: hoverTextColor}}
      pressStyle={{borderColor: 'rgba(108, 117, 125, 0.64)', color: hoverTextColor}}
      style={{
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: 'rgba(108, 117, 125, 0.24)',
        backgroundColor: getBackgroundColor(),
        //flex={1}
        height: "auto",
        padding: 5,
        minHeight: 47,
        justifyContent: "flex-start",
        borderRadius: 15
      }}
    >
      <SimpleText color={'black'} width={25} fontWeight="700" fontSize={15} style={{borderRadius: 100, backgroundColor: "#c9f8d949", textAlign: 'center'}}>
        {['a', 'b', 'c', 'd'][index] || ''}
      </SimpleText>
      <SimpleText color={getTextColor()} fontWeight="500" fontSize={15} flex={1} textAlign="center" hoverStyle={{color: hoverTextColor}}>
        {answer}
      </SimpleText>
    </ActionButton>
  )
}

export const FinancialProfileButton: React.FC<{buttonText?: string}> = (props) => {
  const financialProfileLinkProps = useLink('/financial-profile')
  const buttonText = defaultTo(props.buttonText, 'Complete your Financial Profile First');
  return <ActiveButton {...financialProfileLinkProps} ButtonTextProps={{children: buttonText}} />
}